<template>
	<div>
		<div class="index">
			<div class="m view">
				<div class="body flex_start">
					<!-- <div class="left_img" style="">
						<el-image style="width: 100%; height: 300px" :src="List.cover" fit="cover"
							:preview-src-list="srcList">
							<div slot="error" class="image-slot flex_all" style="height:100%;">
								<i class="el-icon-loading" style="font-size:20px;"></i>
							</div>
						</el-image>
					</div> -->
					<div class="right_font">
						<div class="title">
							{{List.title}}
						</div>
						<!-- 	<div class="flex_start item">
							<span class="label">original</span>
							<img :src="List.o_avatar"
								style="width:30px;height:30px;border-radius:50%;margin-left:10px;cursor:pointer;" />
						</div> -->
						<div class="flex_start item">
							<span class="label">contract address</span>
							<span style="cursor:pointer;">{{List.o_contract_address}}</span>
						</div>
						<div class="flex_start item">
							<span class="label">token ID</span>
							<span style="cursor:pointer;">{{List.tid}}</span>
						</div>
						<!-- 	<div class="item flex_between_x" style="width:200px;">
							<span v-if="List.num==20">versions:{{List.serial}}/{{List.num}}</span>
							<span v-else>versions:1/1</span>
							<div class="flex_start">
								<img src="../../assets/images/index/aixin.png"
									style="width:20px;height:20px;border-radius:50%;margin-right:5px;">
								{{List.fond_count}}
							</div>
						</div> -->
						<!-- <div class="info">
							<p class="title">introduction</p>
							<span>{{List.content}}</span>
						</div> -->
					</div>
				</div>
			</div>
			<div class="m table_list">
				<el-table :data="tableData" empty-text="no results" style="width: 100%;">
					<el-table-column prop="pay_time" label="Timestamp">
					</el-table-column>
					<!-- 	<el-table-column prop="title" label="token Id">
						<template scope="scope">
							<div style="cursor:pointer;" @click="nav_shop(scope.row)">
								{{scope.row.tid}}
							</div>
						</template>
					</el-table-column> -->
					<el-table-column prop="s_contract_address" label="Sender">
						<template scope="scope">
							<div style="cursor:pointer;">
								{{scope.row.s_contract_address}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="r_contract_address" label="Receiver">
						<template scope="scope">
							<div style="cursor:pointer;">
								{{scope.row.r_contract_address}}
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="r_contract_address" label="price">
						<template scope="scope">
							<div style="color:darkred;cursor:pointer;">
								￥{{scope.row.price}}
							</div>
						</template>
					</el-table-column> -->

				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
	function formatDate(value) {
		if (typeof(value) == 'undefined') {
			return ''
		} else {
			let date = new Date(parseInt(value))
			let y = date.getFullYear()
			let MM = date.getMonth() + 1
			MM = MM < 10 ? ('0' + MM) : MM
			let d = date.getDate()
			d = d < 10 ? ('0' + d) : d
			let h = date.getHours()
			h = h < 10 ? ('0' + h) : h
			let m = date.getMinutes()
			m = m < 10 ? ('0' + m) : m
			let s = date.getSeconds()
			s = s < 10 ? ('0' + s) : s
			return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
		}
	}
	export default {
		name: 'index',
		data() {
			return {
				List: [],
				srcList: [],
				total: 0,
				tableData: [],
			}
		},
		mounted() {
			this.get(this.$route.query.tid)
		},
		methods: {
			async get(tid) {
				let res = await this.$api.shopdetails({
					tid: tid
				})
				if (res.code == 200) {
					console.log(res.data[0])
					this.List = res.data[0]
					console.log(res.details)
					this.tableData.push(res.details[0])
					this.tableData.forEach(item => {
						console.log(formatDate(item.pay_time * 1000))
						item.pay_time = formatDate(item.pay_time * 1000)
					})
					this.srcList.push([this.List.photo])
				}
			},
			nav_address() {
				this.$router.push({
					name: 'address',
					query: {
						contract_address: this.List.o_contract_address
					}
				})
			},
			nav_s_address(item) {
				this.$router.push({
					name: 'address',
					query: {
						contract_address: item.s_contract_address
					}
				})
			},
			nav_r_address(item) {
				this.$router.push({
					name: 'address',
					query: {
						contract_address: item.r_contract_address
					}
				})
			},
			// nav_shop(){
			// 	this.$router.push({
			// 		name: 'shop',
			// 		query: {
			// 			tid: this.List.tid
			// 		}
			// 	})
			// },
		}
	}
</script>

<style lang="scss" scoped>
	html,
	body {
		width: 100%;
		height: 100%;
		margin: 0;
	}

	.index {
		width: 100%;
		margin-top: 70px;
		padding-bottom: 100px;

		.view {
			.body {
				width: 100%;
				padding: 100px 80px 100px 0px;
				align-items: flex-start;
				border-radius: 5px;

				.left_img {
					width: 300px;
					height: 300px;
					border-radius: 10px;
					overflow: hidden;
					margin-right: 40px;
				}

				.right_font {
					width: 900px;

					.title {
						font-size: 30px;
						margin-bottom: 20px;
					}

					.item {
						margin-bottom: 20px;
						font-size: 14px;

						.label {
							width: 80px;
						}
					}

					.info {
						.title {
							font-size: 18px;
						}

						span {
							width: 300px;
						}
					}
				}
			}
		}
	}
</style>
